module.exports = __webpack_public_path__ + "static/media/trans-documentation.99e06ea3.svg";